export default (state, selected_exchange_token) => {
  state.selected_exchange_token = selected_exchange_token;
};
